import Vue from 'vue';
import VueRouter from 'vue-router';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

const Webview = () => import('@/views/Webview.vue');
const CheckClientEnv = () => import('@/layouts/CheckClientEnv.vue');
const OrderSearch = () => import('@/views/order/OrderSearch.vue');
const OrderList = () => import('@/views/order/OrderList.vue');
const OrderDetail = () => import('@/views/order/OrderDetail.vue');
const OrderPay = () => import('@/views/order/OrderPay.vue');
const NewOrderDetail = () => import('@/views/order/NewOrderDetail.vue');
const NewOrder = () => import('@/views/order/NewOrder.vue');
const PolicySearch = () => import('@/views/policy/PolicySearch.vue');
const PolicyDetail = () => import('@/views/policy/PolicyDetail.vue');
const ReportSearch = () => import('@/views/report/ReportSearch.vue');
const ReportList = () => import('@/views/report/ReportList.vue');
const ReportDetail = () => import('@/views/report/ReportDetail.vue');
const ProposalSign = () => import('@/views/ProposalSign.vue');
const ProposalTerm = () => import('@/views/ProposalTerm.vue');
const ProposalAuth = () => import('@/views/ProposalAuth.vue');
const ProposalCertify = () => import('@/views/ProposalCertify.vue');
const InsurePayment = () => import('@/views/InsurePayment.vue');
const InsureQRCode = () => import('@/views/InsureQRCode.vue');
const InsureResult = () => import('@/views/InsureResult.vue');
const ReportCertRepair = () => import('@/views/report/ReportCertRepair.vue');
const ReportCertResult = () => import('@/views/report/ReportCertResult.vue');
const WechatPay = () => import('@/views/order/WechatPay.vue');
const WechatCertificate = () => import('@/views/order/WechatCertificate.vue');
const Certify = () => import('@/views/certify/Certify.vue');
const CertifyResult = () => import('@/views/certify/Result.vue');
const Signature = () => import('@/views/signature/Signature.vue');
const SignatureResult = () => import('@/views/signature/Result.vue');
const ProposalSignAnt = () => import('@/views/ant/ProposalSign.vue');
const EProposalIndex = () => import('@/views/EProposalIndex.vue');
const EProposalSms = () => import('@/views/EProposalSms.vue');
const InsuranceFormPayment = () => import('@/views/InsuranceFormPayment.vue');
const ShRealnameEproposal = () => import('@/views/ShRealnameEproposal.vue');
const PayResult = () => import('@/views/PayResult.vue');
const InsureSign = () => import('@/views/InsureSign.vue');
const InsureSignature = () => import('@/views/signature/InsureSignature');
const InsureSignNew = () => import('@/views/InsureSignNew.vue');
const AuthSignature = () => import('@/views/signature/AuthSignature');
const NewEnergy = () => import('@/views/NewEnergy.vue');
const NewLawful = () => import('@/views/NewLawful.vue');
const IdentityCollect = () => import('@/views/IdentityCollect.vue');

Vue.use(VueRouter);

const routes = [
  {
    path: '/webview',
    name: 'webview',
    component: Webview,
  },
  {
    path: '/order-search',
    name: 'order-search',
    component: OrderSearch,
  },
  {
    path: '/order-list',
    name: 'order-list',
    component: OrderList,
  },
  {
    path: '/order-detail',
    name: 'order-detail',
    component: OrderDetail,
  },
  {
    path: '/order-pay',
    name: 'order-pay',
    component: OrderPay,
  },
  {
    path: '/new-order-detail',
    name: 'new-order-detail',
    component: NewOrderDetail,
  },
  {
    path: '/new-order-pay',
    name: 'new-order-pay',
    component: NewOrder,
  },
  {
    path: '/policy-search',
    name: 'policy-search',
    component: PolicySearch,
  },
  {
    path: '/policy-detail',
    name: 'policy-detail',
    component: PolicyDetail,
  },
  {
    path: '/report-search',
    name: 'report-search',
    component: ReportSearch,
  },
  {
    path: '/report-list',
    name: 'report-list',
    component: ReportList,
  },
  {
    path: '/report-detail',
    name: 'report-detail',
    component: ReportDetail,
  },
  {
    path: '/report-cert-repair',
    name: 'report-cert-repair',
    component: ReportCertRepair,
  },
  {
    path: '/report-cert-result',
    name: 'report-cert-result',
    component: ReportCertResult,
  },
  {
    path: '/wechat-pay',
    name: 'wechat-pay',
    component: WechatPay,
  },
  {
    path: '/wechat-certificate',
    name: 'wechat-certificate',
    component: WechatCertificate,
  },
  {
    path: '',
    component: CheckClientEnv,
    children: [
      {
        path: '/proposal-auth',
        name: 'proposal-auth',
        component: ProposalAuth,
      },
      {
        path: '/proposal-certify',
        name: 'proposal-certify',
        component: ProposalCertify,
      },
      {
        path: '/proposal-sign',
        name: 'proposal-sign',
        component: ProposalSign,
      },
      {
        path: '/proposal-term',
        name: 'proposal-term',
        component: ProposalTerm,
      },
      {
        path: '/insure-payment',
        name: 'insure-payment',
        component: InsurePayment,
      },
      {
        path: '/insure-qrcode',
        name: 'insure-qrcode',
        component: InsureQRCode,
      },
      {
        path: '/insure-result',
        name: 'insure-result',
        component: InsureResult,
      },
      {
        path: '/certify',
        name: 'certify',
        component: Certify,
      },
      {
        path: '/certify-result',
        name: 'certify-result',
        component: CertifyResult,
      },
      {
        path: '/signature',
        name: 'signature',
        component: Signature,
      },
      {
        path: '/signature-result',
        name: 'signature-result',
        component: SignatureResult,
      },
      {
        path: '/proposal-sign-ant',
        name: 'proposal-sign-ant',
        component: ProposalSignAnt,
      },
      {
        path: '/eproposal/index',
        name: 'eproposal-index',
        component: EProposalIndex,
      },
      {
        path: '/eproposal/sms',
        name: 'eproposal-sms',
        component: EProposalSms,
      },
      {
        path: '/insurance-form-payment',
        name: 'insurance-form-payment',
        component: InsuranceFormPayment,
      },
      {
        path: '/sh-realname-eproposal',
        name: 'sh-realname-eproposal',
        component: ShRealnameEproposal,
      },
      {
        path: '/pay-result',
        name: 'pay-result',
        component: PayResult,
      },
      {
        path: '/insure-sign',
        name: 'insure-sign',
        component: InsureSign,
      },
      {
        path: '/insure-signature',
        name: 'insure-signature',
        component: InsureSignature,
      },
      {
        path: '/insure-sign-new',
        name: 'insure-sign-new',
        component: InsureSignNew,
      },
      {
        path: '/auth-signature',
        name: 'auth-signature',
        component: AuthSignature,
      },
      {
        path: '/new-energy',
        name: 'new-energy',
        component: NewEnergy,
      },
      {
        path: '/new-lawful',
        name: 'new-lawful',
        component: NewLawful,
      },
      {
        path: '/identity-collect',
        name: 'identity-collect',
        component: IdentityCollect,
      },
    ],
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  NProgress.start();
  next();
});

router.afterEach(to => {
  NProgress.done();
  const { businessNo, mobile, authToken } = to.query;

  import('@/core/recorder').then(({ bindRecord }) => {
    // 绑定 userId（authToken 优先取 URL，否则取 localStorage）
    const userId = authToken || window.localStorage.getItem('authToken');
    if (authToken) {
      window.localStorage.setItem('authToken', authToken);
    }
    if (userId) {
      bindRecord({ userId: mobile ? userId + '_' + mobile : userId });
    }

    // 绑定 businessNo
    if (businessNo) {
      bindRecord({ bizNo: businessNo, bizType: 'proposal' });
    }
  });
});

export default router;
